var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('sweet-modal', {
    ref: _vm.uuid,
    attrs: {
      "id": _vm.configs.id,
      "title": _vm.title,
      "blocking": _vm.configs.blockBlur,
      "overlay-theme": "light",
      "modal-theme": "light"
    },
    on: {
      "close": _vm.closeHandler
    }
  }, [_c('div', {
    staticClass: "slot-content"
  }, [_vm._t("default")], 2), _vm._v(" "), (_vm.configs.showConfirmButton || _vm.configs.showCancelButton) ? _c('div', {
    staticClass: "panel-footer"
  }, [(_vm.configs.showCancelButton) ? _c('button', {
    staticClass: "btn btn-danger",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.cancel($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.configs.cancelText))]) : _vm._e(), _vm._v(" "), (_vm.configs.showConfirmButton) ? _c('button', {
    staticClass: "btn btn-primary-default",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.confirm($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.configs.confirmText))]) : _vm._e()]) : _vm._e()])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4992c94a","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dynamic/modalWrapper/SingleModal.vue
// module id = 1547
// module chunks = 1